import React, { useEffect, useRef, useState } from 'react'
import { Typography } from '@material-ui/core'
import ReactQuill from 'react-quill'
import { DeltaStatic, Sources } from 'quill'

import { normalizeEditorHtml } from './normalizeHtml'
import { useStyles } from './styles'
import 'react-quill/dist/quill.snow.css'

const TOOLBAR_OPTIONS = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
  ['clean'],
]

const EDITOR_MODULES = {
  toolbar: TOOLBAR_OPTIONS,
  clipboard: {
    matchVisual: false,
  },
}

interface DocumentEditorProps {
  label: string
  value: string
  onChange: (value: string) => void
  readOnly?: boolean
}

const DocumentEditor: React.FC<DocumentEditorProps> = ({ label, value, onChange, readOnly }) => {
  const classes = useStyles()
  const [content, setContent] = useState(value)
  const lastPropValue = useRef(value)

  useEffect(() => {
    if (value === lastPropValue.current) return
    lastPropValue.current = value
    setContent(normalizeEditorHtml(value))
  }, [value])

  const handleChange = (next: string, _delta: DeltaStatic, source: Sources) => {
    const normalized = normalizeEditorHtml(next)
    if (normalized === content) return
    setContent(normalized)
    if (source !== 'user') return
    lastPropValue.current = normalized
    onChange(normalized)
  }

  return (
    <div className={classes.root}>
      <Typography variant="subtitle1" className={classes.label}>
        {label}
      </Typography>
      <ReactQuill
        theme="snow"
        value={content}
        onChange={handleChange}
        readOnly={readOnly}
        modules={EDITOR_MODULES}
        className={classes.editor}
      />
    </div>
  )
}

export { DocumentEditor }
